import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { setCommissionPlan } from 'services/plan'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

export default function useSetCommission() {
    const { moneyPool } = useParams()
    const finishFlow = useFinishFlow(FLOWS.fundPlan)
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: number) => {
            return setCommissionPlan(payload)
        },
        onSuccess: (data, variable) => {
            toast.success('صندوق شما با موفقیت به کارمزدی تغییر کرد')
            finishFlow(`/fund/${moneyPool}`)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
